module.exports = __webpack_public_path__ + "lp/img/camera_icn-blue.ad23fc07.svg";